import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactPhoneNumberInput from 'react-phone-number-input';
import { makeStyles } from '@material-ui/core/styles';
import 'react-phone-number-input/style.css';
import TextField from '../InputBase';

const Input = forwardRef(({ onChange, ...otherProps }, ref) => (
  <TextField
    handleChange={onChange}
    inputRef={ref}
    {...otherProps}
  />
));

Input.propTypes = {
  onChange: PropTypes.func.isRequired,
};

// Country flag temporarily disabled
// const CountrySelect = ({ value, onChange, options, ...rest }) => (
//   <select {...rest} value={value} onChange={(e) => onChange(e.target.value)}>
//     {options.map(({ value: val, label }) => (
//       <option key={val || 'ZZ'} value={val}>{label}</option>
//     ))}
//   </select>
// );

const useStyles = makeStyles(() => ({
  root: {
    // Country flag styles temporarily disabled
    // '& .PhoneInputCountry': {
    //   padding: theme.spacing(0, 2),
    //   backgroundColor: theme.palette.lightGrey.main,
    //   marginTop: theme.spacing(2.4),
    //   marginRight: theme.spacing(1),
    // },
    // '& .custom-input-label': {
    //   transform: 'translate(-70px, 0px)',
    // },
    // '& .PhoneInputCountry': {
    //   display: 'none',
    // },
  },
}));

/** This component must be used as a controlled input. */
const PhoneInput = ({
  value, handleChange, ...other
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ReactPhoneNumberInput
        value={value}
        onChange={handleChange}
        inputComponent={Input}
        // Country flag temporarily disabled - use no-op component to prevent
        // country prefix auto-completion when deleting the number
        countrySelectComponent={() => null}
        {...other}
      />
    </div>
  );
};

PhoneInput.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default PhoneInput;
